import { CommonUtilities } from "../../commonUtils";
import Pagination from 'components/Common/newPagination';
import React, { Suspense, useState, useEffect } from "react";
import contractServices from "./contractServices";
import { Filter } from "filter";
import CurrentJobs from "components/User Profile/CurrentJobs";
import EmailStatement from "components/Generation/emailStatement";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import GenerationAllServices from "components/Generation/generationAllServices";

export default function ContractStatmentSummary(contractDetails: any) {


    let [generateStatementStatus, setgenerateStatementStatus] = useState(false);
    let [summaryPdf, setSummaryPdf] = useState(false);
    let [detailPdf, setdetailPdf] = useState(false);
    let [detailExceldetail, setdetailExceldetail] = useState(false);
    let [passParm, SetpassParm] = useState<any>([]);
    let [indicatorValue, SetIndicatorValue] = useState<any>([]);
    let [emailOptionData, setEmailOptionData] = useState<any>([]);
    let [openEmailStatement, setopenEmailStatement] = useState(false);

    console.log(contractDetails)
    useEffect(() => {
        //search();       
        //  
        console.log("passParm")
        console.log(passParm)

        if (passParm?.length == 0 && passParm?.contract != contractDetails?.paramDetail?.contract && passParm?.period?.periodDesc != contractDetails?.paramDetail?.contract) {
            apiCall();
            passParm = contractDetails?.paramDetail
            SetpassParm(passParm)
        }

    }, [contractDetails]);

    const apiCall = () => {
        if (contractDetails?.paramDetail?.contract && contractDetails?.paramDetail?.period?.periodDesc) {
            var payload = {
                contractRefNum: contractDetails?.paramDetail?.contract,
                periodNum: contractDetails?.paramDetail?.period?.periodDesc
            }
            contractServices.overview(payload).then((respond: any) => {
                indicatorValue = respond
                SetIndicatorValue(indicatorValue)
            })
        }
    }

    const EmailStatementClose = () => { setopenEmailStatement(false); }

    const email_option_open = () => {
        openEmailStatement = true
        setopenEmailStatement(openEmailStatement)

        var payload = {
            contract: contractDetails?.paramDetail?.contract,
            periodFrom: Filter?.DateTimeFormatNumber(contractDetails?.paramDetail?.period?.periodFrom),
            periodTo: Filter?.DateTimeFormatNumber(contractDetails?.paramDetail?.period?.periodTo),
            reportType: "Detail|Excel|Summary"
        }

        emailOptionData = payload
        setEmailOptionData(emailOptionData)
        console.log(payload)

    }

    const generationConfirmation = (e: any) => {
        var reportType = ""
        if (reportType.length == 0 && summaryPdf) {
            reportType = "Summary"
        } else {
            reportType = reportType + "|Summary"
        }

        if (reportType.length == 0 && detailPdf) {
            reportType = "Detail"
        } else {
            reportType = reportType + "|Detail"
        }

        if (reportType.length == 0 && detailExceldetail) {
            reportType = "Excel"
        } else {
            reportType = reportType + "|Excel"
        }

        if (e == 1) {
            var payload = {
                OrderByFields: 1, contactNoEmail: 2,
                contract: "2020 - 2025", contractRefNum: "2020 - 2025",
                contractTitle: "", format: "zip",
                isAll: 0, kontactCode: "",
                kontactDisplay: "", listContracts: ["2020 - 2025"],
                method: "download", periodFrom: 20240331,
                periodTo: 20240331, report: "",
                resume: 0, "reportType": reportType
            }
            GenerationAllServices.generate_Statment(payload);
        }

        generateStatementStatus = false;
        setgenerateStatementStatus(generateStatementStatus)

    }

    const reportingDownload = () => {

        var reportType = ""
        if (reportType.length == 0 && summaryPdf) {
            reportType = "Summary"
        } else {
            reportType = reportType + "|Summary"
        }

        if (reportType.length == 0 && detailPdf) {
            reportType = "Detail"
        } else {
            reportType = reportType + "|Detail"
        }

        if (reportType.length == 0 && detailExceldetail) {
            reportType = "Excel"
        } else {
            reportType = reportType + "|Excel"
        }

        var payload = {
            OrderByFields: 1, contactNoEmail: 2,
            contract: "2020 - 2025", contractRefNum: "2020 - 2025",
            contractTitle: "", format: "zip",
            isAll: 0, kontactCode: "",
            kontactDisplay: "", listContracts: ["2020 - 2025"],
            method: "download", periodFrom: 20240331,
            periodTo: 20240331, report: "",
            resume: 0, "reportType": reportType
        }

        GenerationAllServices.downloadStatment(payload);
    }

    return (<>
        <div className="ws-11 positionRelative borderRounded">

            <table className="borderThickGreen tableround borderRounded" style={{ borderRadius: "6px" }}>
                <tbody>
                    <tr className=" borderThickGreen ">
                        <td className="tableroundborderNone pt pb  ">Reporting </td>

                        <td className="tableroundborderNone pb text-center width120">
                            <span> 20240630 </span>

                            <button className="btn-xs icon-btn edit p0 pull-none m0 borderNone" title="Statements History" data-ng-click="statementHistory(contractReportDetails)">
                                <i className="icon-info text-m"></i>
                            </button>
                        </td>

                        <td className="text-right tableroundborderNone pt pb  ">
                            <button className="icon-btn info width90 m0 pull-right"> {indicatorValue?.periodStatus}  </button>
                        </td>
                    </tr>

                    <tr>
                        <td className="borderNone forceSingleLine">Summary : </td>
                        <td className="borderNone text-center">
                            <div className="ws-12">
                                <button className={`icon-btn delete height35 width40 ${summaryPdf ? "fill" : "danger"}`} onClick={() => setSummaryPdf(true)} >
                                    <i className={`icon-file-pdf-o text-l ${summaryPdf ? "white" : ""}`}></i>
                                </button>

                                <button className={`icon-btn edit height35 width40 ${!summaryPdf ? "fill white" : ""}`} onClick={() => setSummaryPdf(false)} >
                                    No
                                </button>
                            </div>

                        </td>

                        <td className="text-center borderNone pt mtl">
                            <button className="icon-btn edit width90 pull-right ws-10" onClick={email_option_open}>  Email   </button>
                        </td>

                    </tr>

                    <tr>
                        <td className="borderNone ">Detail : </td>
                        <td className="borderNone  text-center">

                            <div className=" ws-12">

                                <button className={`icon-btn delete height35 width40 ${detailPdf ? "fill" : "danger"}`} onClick={() => setdetailPdf(true)} >
                                    <i className={`icon-file-pdf-o text-l ${detailPdf ? "white" : ""}`}></i>
                                </button>

                                <button className={`icon-btn edit height35 width40 ${!detailPdf ? "fill white" : ""}`} onClick={() => setdetailPdf(false)} >
                                    No
                                </button>

                            </div>

                        </td>
                        <td className="text-center borderNone pt mtl">

                            <button className="icon-btn edit width90 pull-right " ng-click="reportingGeneration()">
                                Generate
                            </button>
                        </td>
                    </tr>

                    <tr>
                        <td className="tableroundborderNone">Excel :</td>

                        <td className="tableroundborderNone text-center">
                            <div className=" ws-12">

                                <button className={`icon-btn edit height35 width40 ${detailExceldetail ? "fill" : "danger"}`} onClick={() => setdetailExceldetail(true)} >
                                    <i className={`icon-file-excel-o text-l ${detailExceldetail ? "white" : ""}`}></i>
                                </button>

                                <button className={`icon-btn edit height35 width40 ${!detailExceldetail ? "fill white" : ""}`} onClick={() => setdetailExceldetail(false)} >
                                    No
                                </button>

                            </div>

                        </td>

                        <td className="text-center tableroundborderNone">
                            <button className="icon-btn edit width90 pull-right ws-10" onClick={reportingDownload}>
                                Download
                            </button>

                        </td>
                    </tr>


                    <tr className=" borderThickGreen">
                        <td className="borderNone" colSpan={2}><span className="pull-left text-bold text-right mt">Calculated : </span> </td>
                        <td className="borderNone">
                            {indicatorValue?.calculatedDate && <span className="pull-right text-center ps width100" style={{ backgroundColor: "#27ae60", borderRadius: "4px", color: "#FFFFFF" }}>
                                {Filter.SimplemonthAndDayYear(indicatorValue?.calculatedDate)}
                            </span>}
                            {!indicatorValue?.calculatedDate && <span className="pull-right text-center ps width100" style={{ backgroundColor: "#da440f", borderRadius: "4px", color: "#FFFFFF" }} >
                                {Filter.SimplemonthAndDayYear(indicatorValue?.calculatedDate)}
                            </span>}
                        </td>
                    </tr>

                    <tr className=" borderThickGreen">
                        <td className="borderNone" colSpan={2}><span className="pull-left text-bold text-right mt">Generated : </span> </td>
                        <td className="borderNone">
                            {indicatorValue?.generateDate && (indicatorValue?.generateDate > indicatorValue?.calculatedDate) && <span className="pull-right text-center ps width100" style={{ backgroundColor: "#27ae60", borderRadius: "4px", color: "#FFFFFF" }}>
                                {Filter.SimplemonthAndDayYear(indicatorValue?.generateDate)}
                            </span>}
                            {!(indicatorValue?.generateDate && (indicatorValue?.generateDate > indicatorValue?.calculatedDate)) && <span className="pull-right text-center ps width100" style={{ backgroundColor: "#da440f", borderRadius: "4px", color: "#FFFFFF" }} >
                                {Filter.SimplemonthAndDayYear(indicatorValue?.generateDate)}
                            </span>}
                        </td>
                    </tr>

                    <tr className=" borderThickGreen">
                        <td className="borderNone" colSpan={2}><span className="pull-left text-bold text-right mt">Approved : </span> </td>
                        <td className="borderNone">
                            {indicatorValue?.approvedDate && (indicatorValue?.approvedDate > indicatorValue?.generateDate) && <span className="pull-right text-center ps width100" style={{ backgroundColor: "#27ae60", borderRadius: "4px", color: "#FFFFFF" }} >
                                {Filter.SimplemonthAndDayYear(indicatorValue?.approvedDate)}
                            </span>}

                            {(!indicatorValue?.approvedDate || (indicatorValue?.approvedDate < indicatorValue?.generateDate)) && <span className="pull-right text-center ps width100" style={{ backgroundColor: "#da440f", borderRadius: "4px", color: "#FFFFFF" }}>
                                {Filter.SimplemonthAndDayYear(indicatorValue?.approvedDate)}
                            </span>}
                        </td>
                    </tr>

                    <tr className=" borderThickGreen">
                        <td className="borderNone" colSpan={2}><span className="pull-left text-bold text-right mt">Emailed : </span> </td>
                        <td className="borderNone">
                            {indicatorValue?.emailDate && (indicatorValue?.emailDate > indicatorValue?.generateDate) && <span className="pull-right text-center ps width100" style={{ backgroundColor: "#27ae60", borderRadius: "4px", color: "#FFFFFF" }} >
                                {Filter.SimplemonthAndDayYear(indicatorValue?.emailDate ?? "")}
                            </span>}

                            {(!indicatorValue?.emailDate || (indicatorValue?.emailDate < indicatorValue?.generateDate)) && <span className="pull-right text-center ps width100" style={{ backgroundColor: "#da440f", borderRadius: "4px", color: "#FFFFFF" }}>
                                {Filter.SimplemonthAndDayYear(indicatorValue?.emailDate ?? "") ?? "-"}
                            </span>}
                        </td>
                    </tr>

                </tbody>
            </table>

            <div className="ws-12 hide">

                <div className="ws-12 mtl">
                    <span className="pull-left text-bold ws-5 text-right mt">Calculated : </span>
                    <span className="pull-right text-bold text-left pl ws-7 ps"></span>
                </div>

                <div className="ws-12 mt">
                    <span className="pull-left text-bold ws-5 text-right mt">Generated : </span>
                    <span className="pull-right text-bold text-left pl ws-7 ps" style={{ backgroundColor: " #27ae60", borderRadius: "4px", color: "#FFFFFF" }} ng-show="contractDetails.calculatedDate &lt; contractDetails.generateDate "></span>
                    <span className="pull-right text-bold text-left pl ws-7 ps" style={{ backgroundColor: "#da440f", borderRadius: "4px", color: "#FFFFFF" }} ng-show="contractDetails.calculatedDate &gt; contractDetails.generateDate "></span>
                </div>

                <div className="ws-12 mt">
                    <span className="pull-left text-bold ws-5 text-right mt">Approved : </span>
                    <span className="pull-right text-bold text-left pl ws-7 ps"></span>
                </div>
                <div className="ws-12 mt">
                    <span className="pull-left text-bold ws-5 text-right mt">Emailed : </span>
                    <span className="pull-right text-bold text-left pl ws-7 ps"></span>
                </div>
            </div>

            <div className="ws-12 mt">
                <button className="icon-btn edit pull-right btn-s" data-ng-click="updateDates()">
                    <i className="icon-refresh"></i>
                </button>

                <div className="ws-6 pull-right success">
                    <CurrentJobs type="calculation" css="success text-bold " />
                </div>
            </div>

            {(() => {

                if (openEmailStatement) {
                    return <EmailStatement openEmailStatement={openEmailStatement} emailOptionData={emailOptionData} EmailStatementClose={EmailStatementClose} />;
                }

                if (generateStatementStatus) {
                    return <DeleteDialogueBox param={generateStatementStatus} message={"to proceed with the generation(s) "} onChange={generationConfirmation} />
                }


            })()}

        </div>

    </>)

}